export const SA_COMPANIES_PAGE_SIZES = [20, 25, 50, 100]

export const SA_COMPANIES_INITIAL_FILTERS = {
  page: 1,
  per_page: 20,
  q: '',
  billing_state: '',
  lifecycle_status: '',
  subscription_status: '',
  usage_status: '',
  health_status: '',
  package_id: '',
  created_from: '',
  created_to: '',
  field_order: 'id',
  type_order: 'desc',
}

export const SA_ATTENTION_INITIAL_FILTERS = {
  page: 1,
  per_page: 20,
  severity: '',
}

export const SA_ACTIVITY_INITIAL_FILTERS = {
  page: 1,
  per_page: 20,
}

export const SA_DELETIONS_INITIAL_FILTERS = {
  page: 1,
  per_page: 20,
  q: '',
  type: '',
}

export const SA_DELETION_TYPE_VALUES = ['user', 'company']

export const SA_COMPANY_SORT_WHITELIST = ['id', 'name', 'status', 'created_at', 'package_id', 'timezone']

export const SA_SUBSCRIPTION_STATUS_VALUES = ['active', 'expiring', 'expired', 'suspended']

export const SA_USAGE_STATUS_VALUES = ['active', 'low_activity', 'inactive', 'never_activated']

export const SA_HEALTH_STATUS_VALUES = ['healthy', 'warning', 'critical']

export const SA_SAFE_HEALTH_PATH = /^\/admin\/companies\/(\d+)\/health$/

export const SA_INTEGRATION_KEYS = ['stripe', 'paypal', 'twilio']
